import { cn } from '@latitude/token-utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import type { ComponentRef, Ref } from 'react';
import { useEffect, useState } from 'react';
import type { SwitchLabelProps, SwitchProps } from 'types';

import {
  switchLabelVariants,
  switchVariants,
  thumbVariants,
} from './variants/switch-variants';

export const Switch = ({
  className,
  size,
  checked,
  ref,
  ...props
}: SwitchProps & {
  ref?: Ref<ComponentRef<typeof SwitchPrimitives.Root>>;
}) => {
  const [value, setValue] = useState(checked);

  useEffect(() => {
    setValue(checked);
  }, [checked]);
  return (
    <SwitchPrimitives.Root
      className={cn(switchVariants({ size }), className)}
      {...props}
      checked={value}
      ref={ref}
    >
      <SwitchPrimitives.Thumb className={cn(thumbVariants({ size }))} />
    </SwitchPrimitives.Root>
  );
};
Switch.displayName = SwitchPrimitives.Root.displayName;

export const SwitchLabel = ({
  className,
  size,
  ref,
  ...props
}: SwitchLabelProps & {
  ref?: Ref<ComponentRef<typeof LabelPrimitive.Root>>;
}) => {
  return (
    <LabelPrimitive.Root
      {...props}
      ref={ref}
      className={cn(switchLabelVariants({ size }), className)}
    />
  );
};

SwitchLabel.displayName = LabelPrimitive.Root.displayName;

export { type SwitchProps, type SwitchLabelProps };
